import React, { useMemo, memo } from 'react';
import { View, TouchableHighlight } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { Avatar } from 'design-system/avatar';
import { CIRCLE_BORDER_SIZE, CIRCLE_SIZE } from 'design-system/LogoBankAccount';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { SELECTED_ITEM_HEIGHT } from '../constants';
const ContactItem = ({ onPress, contact, children }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const { thumbnailPath } = contact;
    const userInfoToShow = useMemo(() => {
        const { phoneNumbers, handle, friendsCount } = contact;
        if (handle)
            return `@${handle}`;
        if (friendsCount) {
            return friendsCount > 1
                ? `${friendsCount} friends on Emma`
                : `${friendsCount} friend on Emma`;
        }
        if (phoneNumbers && phoneNumbers.length > 0) {
            return phoneNumbers
                .map((it) => it.number)
                .reduce((prev, curr) => `${prev}, ${curr}`);
        }
        return undefined;
    }, [contact]);
    const content = (<View style={styles.row}>
      <Avatar imageUrl={thumbnailPath} name={contact.givenName ?? contact.nameToShow ?? '?'} lastName={contact.familyName ?? ''} color={colors.background.brandLight} size={CIRCLE_SIZE} borderWidth={CIRCLE_BORDER_SIZE} fontColor={colors.text.textOnBrand} medium/>

      <View style={styles.textContainer}>
        <Text Text-16 numberOfLines={1}>
          {contact.nameToShow ??
            `${contact.givenName || '?'}${contact.familyName ? ` ${contact.familyName}` : ''}`}
        </Text>
        <Text TextThin-14 Gray numberOfLines={1}>
          {userInfoToShow}
        </Text>
      </View>
      {children}
    </View>);
    if (!onPress) {
        return content;
    }
    return (<TouchableHighlight onPress={onPress} underlayColor={colors.background.underlay} activeOpacity={1}>
      {content}
    </TouchableHighlight>);
};
const styleSet = createStyleSheets(() => ({
    row: {
        height: SELECTED_ITEM_HEIGHT,
        paddingHorizontal: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
    },
    textContainer: {
        flex: 1,
        marginLeft: rem(16),
        justifyContent: 'center',
    },
}));
export default memo(ContactItem);
